var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"row col-12",staticStyle:{"margin-left":"200px"}},[_c('div',{staticClass:"col-3"}),_c('div',{staticClass:"col-3"}),_c('div',{staticClass:"col-3"}),_c('div',{staticClass:"col-3",staticStyle:{"padding-right":"200px"}},[_c('p',[_vm._v("© 2024 Mount Street Group")]),_c('p',[_vm._v("v2.0.0")])])])])
}]

export { render, staticRenderFns }